import { combineReducers } from 'redux';
import formPaymentActivationReducer from 'src/components/FormPaymentActivation/redux/reducers';
import { userManagementReducer } from 'src/pages/Accounts/UserManagement/redux';
import apiInquiryReducer from 'src/pages/ApiInquiry/redux/reducers';
import apiOfflineReducer from 'src/pages/ApiOffline/redux/reducers';
import bridgedReducer from 'src/pages/BridgingReport/redux/reducers';
import bulkDisbursementReducer from 'src/pages/Disbursement/Bulk/redux/reducers';
import claimFundReducer from 'src/pages/Disbursement/ClaimFund/redux/reducers';
import internationalRemitReducer from 'src/pages/Disbursement/InternationalRemit/redux/reducers';
import offlineCashWithdrawalReducer from 'src/pages/Disbursement/OfflineCashWithdrawal/redux/reducers';
import formActivationBcaVaReducer from 'src/pages/FormActivation/BcaVa/redux/reducers';
import accountingPlatformReducer from 'src/pages/Integration/ConfigureAccount/redux/reducers';
import cashDeliveryReducer from 'src/pages/RequestMoney/CashDelivery/constants/CashDeliveryReducer';
import offlineCashDepositReducer from 'src/pages/RequestMoney/OfflineCashDeposit/redux/reducers';
import paymentCheckoutReducer from 'src/pages/RequestMoney/redux/reducers';
import autoReportConfigReducer from 'src/pages/Settings/AutoReport/redux/reducers';
import autoWithdrawalReducer from 'src/pages/Settings/AutoWithdrawalReport/redux/reducers';
import bankAccountReducer from 'src/pages/Settings/BankAccount/redux/reducers';
import developerOptionsReducer from 'src/pages/Settings/DeveloperOptions/redux/reducers';
import multiApprovalReducer from 'src/pages/Settings/MultiApproval/redux/reducers';
import notificationReducer from 'src/pages/Settings/Notification/redux/reducers';
import delayedSettlementReducer from 'src/pages/TransactionReport/SettlementReport/redux/reducers';
import apiTransactionsDataReducer from 'src/pages/TxData/APITransactionsData/redux/reducers';
import registerTxDataReducer from 'src/pages/TxData/RegistrationPage/redux/reducers';
import createNewVaReducer from 'src/pages/VirtualAccount/CreateNewVA/redux/reducers';
import createdVaReducer from 'src/pages/VirtualAccount/CreatedVa/redux/reducers';
import vaReducer from 'src/pages/VirtualAccount/redux/reducers';
import accountStatementReducer from './accountStatementReducer';
import authReducer from './authReducer';
import bcaUniqueCodeReducer from './bcaUniqueCodeReducer';
import bulkTransferReducer from './bulkTransferReducer';
import businessBankingReducer from './businessBankingReducer';
import createBulkDisbursementReducer from './createBulkDisbursementReducer';
import devConfigSlice from './devConfigSlice';
import exportReducer from './exportReducer';
import mainReducer from './mainReducer';
import manualTopupReducer from './manualTopupReducer';
import notificationAnnouncementPreviewReducer from './notificationAnnouncementPreviewReducer';
import permissionReducer from './permissionReducer';
import pinReducer from './pinReducer';
import productConfigsReducer from './productConfigReducer';
import productStatusReducer from './productStatusReducer';
import signLegalDocumentReducer from './signLegalDocumentReducer';
import userFeedbackReducer from './userFeedbackReducer';

export const rootReducer = combineReducers({
  main: mainReducer,
  accountingPlatform: accountingPlatformReducer,
  accountStatement: accountStatementReducer,
  apiInquiry: apiInquiryReducer,
  apiOffline: apiOfflineReducer,
  apiTxData: apiTransactionsDataReducer,
  auth: authReducer,
  autoReportConfig: autoReportConfigReducer,
  autoWithdrawal: autoWithdrawalReducer,
  bankAccount: bankAccountReducer,
  bcaUniqueCode: bcaUniqueCodeReducer,
  bridged: bridgedReducer,
  bulkDisbursement: bulkDisbursementReducer,
  bulkTransfer: bulkTransferReducer,
  businessBanking: businessBankingReducer,
  cashDelivery: cashDeliveryReducer,
  claimFund: claimFundReducer,
  createBulkDisbursement: createBulkDisbursementReducer,
  createdVa: createdVaReducer,
  createNewVa: createNewVaReducer,
  delayedSettlement: delayedSettlementReducer,
  devConfig: devConfigSlice,
  developerOptions: developerOptionsReducer,
  export: exportReducer,
  formActivationBcaVa: formActivationBcaVaReducer,
  formPaymentActivation: formPaymentActivationReducer,
  internationalRemit: internationalRemitReducer,
  manualTopup: manualTopupReducer,
  multiApproval: multiApprovalReducer,
  notification: notificationReducer,
  notificationAnnouncementPreview: notificationAnnouncementPreviewReducer,
  offlineCashDeposit: offlineCashDepositReducer,
  offlineCashWithdrawal: offlineCashWithdrawalReducer,
  paymentCheckout: paymentCheckoutReducer,
  permission: permissionReducer,
  pin: pinReducer,
  productConfigs: productConfigsReducer,
  productStatus: productStatusReducer,
  registerTxData: registerTxDataReducer,
  signLegalDocument: signLegalDocumentReducer,
  userFeedback: userFeedbackReducer,
  userManagement: userManagementReducer,
  va: vaReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
